module.exports = __webpack_public_path__ + "static/media/onboarding10.4fb0d412.svg";